// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"c3236f5e","234":"4eabc6bc","351":"5253970d","379":"0fea8ad2","423":"40b9a394","530":"4884f70c","627":"7741b30b","874":"10667902","974":"3705f6cc"}[chunkId] + ".chunk.js";
};